/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports.reconciliations
 * @name ReportsReconciliationTipsCtrl
 */
angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationTipsCtrl', ["$scope", "PosTips", "reporttime", "title", function($scope, PosTips, reporttime, title) {

  $scope.tipsGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Tips', type: 'number', key: 'amount', filter: 'currency'}
  ];

  title.set('Tips');
  $scope.loading = PosTips.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());

  $scope.loading.then(function(results) {
    $scope.tips = results;
  });
}]);
